import { useState } from "react";

import Image from "next/legacy/image";

import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

const AutoFadSlider = ({ images }) => {
  const [opacities, setOpacities] = useState([]);

  const [sliderRef] = useKeenSlider(
    {
      slides: images.length,
      drag: false,
      loop: true,
      renderMode: "performance",
      detailsChanged(s) {
        const new_opacities = s.track.details.slides.map(
          (slide) => slide.portion
        );
        setOpacities(new_opacities);
      },
    },

    [
      (slider) => {
        let timeout;

        function clearNextTimeout() {
          clearTimeout(timeout);
        }

        function nextTimeout() {
          clearTimeout(timeout);

          timeout = setTimeout(() => {
            slider.next();
          }, 5000);
        }
        slider.on("created", () => {
          nextTimeout();
        });

        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
        slider.on("optionsChanged", nextTimeout);
        slider.on("destroyed", clearNextTimeout);
      },
    ]
  );

  return (
    <>
      <div ref={sliderRef} className="fader">
        {images.map((src, idx) => (
          <div
            key={idx}
            className="fader__slide relative h-full w-full"
            style={{ opacity: opacities[idx] }}
          >
            <Image
              src={src}
              alt="Slide Image"
              layout="fill"
              quality={100}
              objectFit="cover"
              priority
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default AutoFadSlider;

export const LiveMatchAutoFadeSlider = ({ images }) => {
  const [opacities, setOpacities] = useState([]);

  const [sliderRef] = useKeenSlider(
    {
      slides: images.length,
      drag: false,
      loop: true,
      renderMode: "performance",
      detailsChanged(s) {
        const new_opacities = s.track.details.slides.map(
          (slide) => slide.portion
        );
        setOpacities(new_opacities);
      },
    },

    [
      (slider) => {
        let timeout;

        function clearNextTimeout() {
          clearTimeout(timeout);
        }

        function nextTimeout() {
          clearTimeout(timeout);

          timeout = setTimeout(() => {
            slider.next();
          }, 5000);
        }
        slider.on("created", () => {
          nextTimeout();
        });

        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
        slider.on("optionsChanged", nextTimeout);
        slider.on("destroyed", clearNextTimeout);
      },
    ]
  );

  return (
    <>
      <div ref={sliderRef} className="live-match-fader">
        {images.map((src, idx) => (
          <div
            key={idx}
            className="live_match_fader__slide relative h-full w-full"
            style={{ opacity: opacities[idx] }}
          >
            <Image
              src={src}
              alt="Slide Image"
              layout="fill"
              quality={100}
              objectFit="cover"
              priority
            />
          </div>
        ))}
      </div>
    </>
  );
};
